export default "__VITE_ASSET__BCZ8EfM3__"